import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../components/shared";
import { useAuth } from "../context/AuthContext";
import { apiErr } from "../lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const { googleExchange } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const qs = new URLSearchParams(window.location.search);
    const code = qs.get("code");
    // role is carried through the OAuth `state` param (set at login time for register)
    const role = new URLSearchParams(qs.get("state") || "").get("role");
    // Redirect URI must match exactly what was sent to Google (and registered in Console).
    const redirectUri = window.location.origin + "/auth/google";
    if (!code) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const u = await googleExchange(code, redirectUri, role);
        window.history.replaceState(null, "", "/");
        navigate(u.role === "admin" ? "/admin" : u.role === "organizer" ? "/organizer" : "/discover", { replace: true });
      } catch (e) {
        setError(apiErr(e));
        toast.error("Google sign-in failed.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [googleExchange, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <Spinner className="w-8 h-8 text-primary" />
        <span className="overline">{error || "Signing you in"}</span>
      </div>
    </div>
  );
}
